import { createApp } from 'vue';

import {
    showAddModal,
    saveAdd,
} from '@js/modules/parts/mymemory_edit';

const app = createApp({
    data: () => {
        return {
            url_text: '',
        };
    },
    methods:{
        showAddModal,
        saveAdd,
    }
});
app.mount('#app');
